
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics/[...alias]",
      function () {
        return require("private-next-pages/topics/[...alias].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics/[...alias]"])
      });
    }
  